module.exports = __webpack_public_path__ + "static/media/talent-donation-love.fabb794f.svg";